import { DropdownItem } from '@/common/components';

export enum InputType {
  EMAIL = 'email',
  NUMBER = 'number',
  PHONE = 'phone',
  SELECT = 'select',
  TEXT = 'text',
}

export interface EntryForm {
  id?: string;
  name: string;
  options?: DropdownItem[];
  required?: boolean;
  section: string;
  target: string | number;
  type: string;
  isSensitive?: boolean; // New property to indicate if the input is sensitive
}

export interface Options {
  id: string;
  value: string;
}

export interface CustomFormProps {
  data: EntryForm[];
  isEditing?: boolean;
  onSubmit?: (values: EntryForm[]) => void;
}

export enum SectionName {
  DETAILS = 'details',
  INFO = 'info',
  SERVICE = 'service',
}
